import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearVoucherTypes,
  getVoucherTypes,
} from '../../../../actions/accounting/VoucherType';
import { VOUCHER_TYPE_PATH, NEW_VOUCHER_TYPE_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import {  VOUCHER_TYPE_COLUMNS } from '../../../../config/columns';

export const VoucherTypes = ({
  breadcrumbs,
  vouchertType,
  loading,
  dispatchGetVoucherTypes,
  dispatchClearVoucherTypes,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearVoucherTypes();
    },
    [],
  );

  const data = vouchertType.get('content') || [];
  const pages = vouchertType.get('totalPages') || null;
  const defaultPageSize = vouchertType.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Tipos de Comprobantes"
      buttonPath={NEW_VOUCHER_TYPE_PATH}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: VOUCHER_TYPE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetVoucherTypes,
        loading,
        modelPath: VOUCHER_TYPE_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetVoucherTypes: getVoucherTypes,
  dispatchClearVoucherTypes: clearVoucherTypes,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Comprobantes',
      href: VOUCHER_TYPE_PATH,
    },
  ],
  vouchertType: AccountingUnit.VoucherType.getIn(['all', 'content']),
  loading: AccountingUnit.VoucherType.getIn(['all', 'loading']),
});

VoucherTypes.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  vouchertType: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetVoucherTypes: PropTypes.func.isRequired,
  dispatchClearVoucherTypes: PropTypes.func.isRequired,
};

VoucherTypes.defaultProps = {
  vouchertType: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherTypes);
